import { useEffect, useState } from 'react';
import { FormCheck } from 'react-bootstrap';
import TimePicker from '../../../components/picker/TimePicker';
import {
  dateToTimeString,
  dateToYmdString,
  stringToTime,
  stringToYmdDate,
} from '../../../utils/datepickerUtil';
import SubmitAndCancelButton from '../../../components/button/SubmitAndCancelButton';
import ProjectNumberSearch from '../../../components/search/ProjectNumberSearch';
import { SuggestionForBusinessReport } from '../../../types/search/SuggestionForBusinessReport';
import { formatProjectName } from '../../../utils/formatProjectName';
import {
  BusinessReportPutRequest,
  MAN_HOURS_CATEGORY_KEYS,
} from '../../../types/businessReport/BusinessReportPutRequest';
import YmdPicker from '../../../components/picker/YmdPicker';

interface Props {
  item: BusinessReportPutRequest;
  onChange: (
    key: keyof BusinessReportPutRequest,
    value: string | boolean | number
  ) => void;
  onSubmit: (itemId: number) => void;
  onCancel: (itemId: number) => void;
}

const EditBusinessReportRow = ({
  item,
  onChange,
  onSubmit,
  onCancel,
}: Props) => {
  // 小数点以下も表示するため文字列で保持（親へは number を反映）
  const [manHourTotal, setManHourTotal] = useState<string>(
    item.manHoursTotal.toString()
  );

  // 始業/終業の変更で工数合計を自動計算
  useEffect(() => {
    if (item.startTime == null || item.endTime == null) return;
    const start = stringToTime(item.startTime);
    const end = stringToTime(item.endTime);
    if (start == null || end == null) return;

    const diff = (end.getTime() - start.getTime()) / (1000 * 60 * 60);
    setManHourTotal(diff.toString());
    onChange('manHoursTotal', diff);
  }, [item.startTime, item.endTime]);

  return (
    <>
      {/* 日付（編集可：YmdPicker） */}
      <td>
        <YmdPicker
          selectedDate={stringToYmdDate(item.date)}
          setSelectedDate={(picked) => {
            onChange('date', dateToYmdString(picked));
          }}
        />
      </td>

      {/* PJ No 検索（初期値＝保存済みの PJ No） */}
      <td>
        <ProjectNumberSearch
          initialQuery={item.projectNo}
          onSearch={(data) => {
            onChange('projectId', data.value);
            onChange('projectNo', data.projectNumber);
            onChange('projectName', data.label);
          }}
        />
      </td>

      {/* プロジェクト名（検索結果があればそれ、無ければ保存済み表示） */}
      <td>{formatProjectName(item.projectName)}</td>

      {/* 工数A〜E（ラジオ：ローカル category → 親へフラグ展開） */}
      {MAN_HOURS_CATEGORY_KEYS.map((key) => (
        <td key={key}>
          <FormCheck
            type="radio"
            name={`manHoursCategory-edit-${item.id}`}
            checked={item.manHoursCategory === key}
            onChange={() => onChange('manHoursCategory', key)}
          />
        </td>
      ))}

      {/* 始業/終業（TimePicker） */}
      <td>
        <TimePicker
          selectedTime={stringToTime(item.startTime)}
          setSelectedTime={(time) =>
            onChange('startTime', time ? dateToTimeString(time) : '')
          }
        />
      </td>
      <td>
        <TimePicker
          selectedTime={stringToTime(item.endTime)}
          setSelectedTime={(time) =>
            onChange('endTime', time ? dateToTimeString(time) : '')
          }
        />
      </td>

      {/* 工数合計（文字列表示） */}
      <td>{manHourTotal}</td>

      {/* 保存/キャンセル */}
      <td>
        <SubmitAndCancelButton
          onSubmit={() => onSubmit(item.id)}
          onCancel={() => onCancel(item.id)}
        />
      </td>
    </>
  );
};

export default EditBusinessReportRow;
